import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import NewPhoneNumberComponent from "../../../../../common/components/new-phone-input-component/new-phone-input-component";
import "./registration-forms.scss";
import { compactInputProps } from "../partner-registration-form.utils";

const PrimaryInformationForm: React.FC<{ formik: any }> = ({ formik }) => {

  function handleChange(event: {
    target: { name: string; value: string };
  }): void {
    const { name, value } = event.target;
    formik.setFieldValue(name, value);
  }
  return (
    <Box
      className="primary-information-form"
      sx={{
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
        {
          borderWidth: "1px",
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
        "& .MuiFormHelperText-root": {
          margin: 0,
          padding: 0,
          lineHeight: "16px",
        },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography className="form-label">
            Primary Contact Name<span>*</span>
          </Typography>
          <TextField
            fullWidth
            name="primaryContactName"
            placeholder="Enter primary contact name"
            required
            InputProps={compactInputProps}
            value={formik.values.primaryContactName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.primaryContactName &&
              Boolean(formik.errors.primaryContactName)
            }
            inputProps={{ maxLength: 50 }}
            helperText={
              formik.touched.primaryContactName &&
              formik.errors.primaryContactName
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="form-label">
            Contact Role/Designation<span>*</span>
          </Typography>
          <TextField
            fullWidth
            name="primaryContactRole"
            placeholder="Enter contact role/designation"
            required
            InputProps={compactInputProps}
            value={formik.values.primaryContactRole}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.primaryContactRole &&
              Boolean(formik.errors.primaryContactRole)
            }
            inputProps={{ maxLength: 50 }}
            helperText={
              formik.touched.primaryContactRole &&
              formik.errors.primaryContactRole
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography className="form-label">
            Primary Contact Phone
            <span>*</span>
          </Typography>
          <Box
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "4px !important",
                height: "39px !important",
                maxWidth: "100%",
              },
              "& .MuiInputBase-root": {
                fontSize: "14px",
                height: "39px !important",
                padding: "10px 6px !important",
              },
              "& .MuiInputAdornment-root": {
                backgroundColor: "#FFFFFF",
                borderRadius: "6px 0 0 6px",
              },
              "& input": {
                color: "#104145 !important",
              },
            }}
          >
            <NewPhoneNumberComponent
              value={formik.values.primaryContactPhone}
              onChange={(mobileValue: string) => {
                const cleanedValue = String(mobileValue || "").replace(/\D/g, "");
                formik.setFieldValue("primaryContactPhone", cleanedValue);
                formik.setFieldTouched("primaryContactPhone", true, false);
              }}
              countryCode={formik.values.primaryContactPhoneCC}
              onCountryChange={(countryCode: string) =>
                formik.setFieldValue("primaryContactPhoneCC", countryCode)
              }
              placeholder="Enter primary contact phone number"
              error={
                formik.touched.primaryContactPhone &&
                Boolean(formik.errors.primaryContactPhone)
              }
              helperText={
                formik.touched.primaryContactPhone &&
                formik.errors.primaryContactPhone
              }
              showHelper={true}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="form-label">
            Primary Contact Email<span>*</span>
          </Typography>
          <TextField
            fullWidth
            name="primaryContactEmail"
            placeholder="Enter primary contact email"
            type="email"
            required
            InputProps={compactInputProps}
            value={formik.values.primaryContactEmail}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { value } = e.target;
              formik.setFieldValue("primaryContactEmail", value.replace(/\s/g, ""));
            }}
            onBlur={formik.handleBlur}
            error={
              formik.touched.primaryContactEmail &&
              Boolean(formik.errors.primaryContactEmail)
            }
            inputProps={{ maxLength: 150 }}
            helperText={
              formik.touched.primaryContactEmail &&
              formik.errors.primaryContactEmail
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PrimaryInformationForm;
